import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Writers } from '../models';
declare const swal: any;
declare var $: any;

@Component({
  selector: 'app-our-writters',
  templateUrl: './our-writters.component.html',
  styleUrls: ['./our-writters.component.css']
})
export class OurWrittersComponent implements OnInit {

  writerscol:AngularFirestoreCollection<Writers>;
  writers:Observable<Writers[]>;
  id:any;
   constructor(private afs:AngularFirestore) { }
 
   ngOnInit() {
     this. writerscol=this.afs.collection("writers",res =>{
       return res.orderBy('createdAt', 'desc')
     });
     this.writers=this.writerscol.valueChanges();
   }
 
   delete(id) {
     console.log(id);
     this.id = id;
     $("#DeleteModal").modal();
   }
   deletedata() {
     $('#DeleteModal').modal('hide');
       this.afs.doc('/writers/'+this.id).delete().then(function () {  
         swal('Deleted!', 'Your writer has been deleted.', 'success');
       }).catch(function(error){
         swal('Error!', error, 'error');
         console.error("error in removing document:",error);
       });
   }
 
}



// WEBPACK FOOTER //
// ./src/app/our-writters/our-writters.component.ts